export const clientIdRegistry = {
  smile: '7f03287f-0fb4-4bc5-ae3c-f04d10b71b57',
};
